module.exports = __webpack_public_path__ + "static/media/reviews-loyalty-wishlist.1a087260.png";